
  import { Component, Vue, PropSync } from 'vue-property-decorator';
  import { mcUserMessages, mcLabels } from "@/view-models";
  import { types } from '@/store';
  import { eventBus, mcEvents, mcLogger } from '@/utils';

  @Component
  export default class CountMeals extends Vue {
    changesSaved = false
    changesAffirmed = false;
    dirty = false;
    countComparison = false;
    kickedFromServingLine = false;

    labels = mcLabels.modalTitles;

    /** Fancy colored logger */
    private console: Console = mcLogger.getConsole(this.constructor.name, mcLogger.colors.CountMeals);

    mounted() {
      eventBus.$on(mcEvents.kickedFromServingLine, this.handleKickedFromServingLine);
    }

    beforeDestroy() {
      eventBus.$off(mcEvents.kickedFromServingLine, this.handleKickedFromServingLine);
    }

    get isAuthenticated() {
      return this.$store.getters[types.state.isAuthenticated];
    }

    saved(value) {
      this.changesSaved = value;
    }

    affirmed(value) {
      this.changesAffirmed = value;
    }

    countCheck(value) {
      this.countComparison = value;
    }

    isDirty(value) {
      this.dirty = value;
    }

    get checkDirty() {
      return !this.changesSaved && !this.changesAffirmed && this.dirty;
    }

    get checkSubmitted() {
      return this.changesSaved && !this.changesAffirmed && this.countComparison;
    }

    handleKickedFromServingLine() {
      this.kickedFromServingLine = true;
    }

    notSaved(next) {
      this.$bvModal.msgBoxConfirm(mcUserMessages.serveMeals.discardCounts, {
        title: this.labels.discard,
        okTitle: 'DISCARD',
        cancelTitle: 'CANCEL',
        cancelVariant: 'cancel',
        footerClass: 'p-2',
        hideHeaderClose: false
      }).then(value => {
        // If they chose discard, then clear the tempCounts
        if(value === true) {
          /* Should this be a utility method somewhere? In mc-meal-wizard.vue there is clearTempCounts() that has the
          * same line called. Or is this line effectively that? If that's the case, then should clearTempCounts
          * be removed and where it's called this line be placed?
          */
          this.$store.dispatch(types.actions.setTempDto, {});
        }
        next(value);
      })
    }

    notSubmitted(next) {
      this.$bvModal.msgBoxConfirm(mcUserMessages.serveMeals.unsubmittedCounts, {
        title: this.labels.unsubmitted,
        okTitle: 'LEAVE',
        cancelTitle: 'STAY',
        cancelVariant: 'cancel',
        footerClass: 'p-2',
        hideHeaderClose: false,
      }).then(value => {
        next(value);
      })
    }

    beforeRouteLeave(to, from, next) {
      if (this.kickedFromServingLine) {
        next();
      }
      else if (this.checkDirty) {
        this.notSaved(next);
      }
      else if (this.checkSubmitted) {
        this.notSubmitted(next);
      }
      else {
        next();
      }
    }
  }
